// Use a stable local callback instead of copying /login or a protected page.
// Production keeps its existing callback until its Entra registration changes.
export function microsoftRedirectUri(location = window.location, returnTo = null) {
    const local = ['localhost', '127.0.0.1', '[::1]'].includes(location.hostname);
    return location.origin + (local || safeLoginReturnPath(returnTo, location.origin) ? '/' : location.pathname);
}

export function safeLoginReturnPath(value, origin = window.location.origin) {
    if (!value) return null;
    try {
        const url = new URL(value, origin);
        return url.origin === origin && /^\/esave\/?$/.test(url.pathname) ? url.pathname + url.search : null;
    } catch { return null; }
}

export function resumeLoginReturn(location = window.location, storage = sessionStorage) {
    const target = safeLoginReturnPath(storage.getItem('msal_return_to'), location.origin);
    storage.removeItem('msal_return_to');
    if (!target || target === location.pathname + location.search) return false;
    location.replace(target);
    return true;
}

export function loginError(message) {
    if (typeof message !== 'string' || !message.trim()) {
        return 'No se ha podido iniciar la sesión. Vuelve a intentarlo.';
    }
    if (/not yet valid|immature/i.test(message)) {
        return 'La hora de emisión de la sesión está adelantada respecto al servidor. Espera unos segundos y vuelve a entrar. Si persiste, hay que revisar el reloj del servicio de autenticación.';
    }
    if (/expired/i.test(message)) return 'La sesión ha caducado. Vuelve a iniciar sesión.';
    if (/Failed to fetch|NetworkError|Load failed/i.test(message)) {
        return 'No se ha podido conectar con el servicio de autenticación o con Espuma. Vuelve a intentarlo.';
    }
    if (/Agent not found|unauthorized/i.test(message)) {
        return 'La sesión no corresponde a un agente autorizado de Espuma. Hay que revisar la asociación de esta cuenta con su agente.';
    }
    return message;
}

export async function validateLoginSession(token) {
    if (typeof token !== 'string' || !token.trim()) {
        throw new Error('El servicio de autenticación no ha devuelto una sesión válida.');
    }
    const response = await fetch('/api/agents/me', {
        headers: { Authorization: `Bearer ${token}` },
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
        throw new Error(loginError(data.message || data.error || 'No se ha podido validar la sesión en Espuma.'));
    }
    if (!data.id) throw new Error('Espuma no ha devuelto el perfil del agente. Vuelve a intentarlo.');
    return data;
}
